import { cn } from "@theprelude/core";

export const GoogleIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0367 6.6945H14.4997V6.66683H8.49967V9.3335H12.2673C11.7177 10.8858 10.2407 12.0002 8.49967 12.0002C6.29067 12.0002 4.49967 10.2092 4.49967 8.00016C4.49967 5.79116 6.29067 4.00016 8.49967 4.00016C9.51934 4.00016 10.447 4.38483 11.1533 5.01316L13.039 3.1275C11.8483 2.01783 10.2557 1.3335 8.49967 1.3335C4.81801 1.3335 1.83301 4.3185 1.83301 8.00016C1.83301 11.6818 4.81801 14.6668 8.49967 14.6668C12.1813 14.6668 15.1663 11.6818 15.1663 8.00016C15.1663 7.55316 15.1203 7.11683 15.0367 6.6945Z"
      fill="#FBC02D"
    />
    <path
      d="M2.60167 4.89716L4.79201 6.5035C5.38467 5.03616 6.82001 4.00016 8.49967 4.00016C9.51934 4.00016 10.447 4.38483 11.1533 5.01316L13.039 3.1275C11.8483 2.01783 10.2557 1.3335 8.49967 1.3335C5.93901 1.3335 3.71834 2.77916 2.60167 4.89716Z"
      fill="#E53935"
    />
    <path
      d="M8.49967 14.6668C10.2217 14.6668 11.7863 14.0078 12.9693 12.9362L10.906 11.1902C10.2367 11.6972 9.40467 12.0002 8.49967 12.0002C6.76567 12.0002 5.29334 10.8945 4.73867 9.3515L2.56467 11.0265C3.66801 13.1855 5.90867 14.6668 8.49967 14.6668Z"
      fill="#4CAF50"
    />
    <path
      d="M15.0367 6.6945L15.0313 6.66683H14.4997H8.49967V9.3335H12.2673C12.0033 10.0792 11.5237 10.7222 10.905 11.1905L10.906 11.1902L12.9693 12.9362C12.8233 13.0688 15.1663 11.3335 15.1663 8.00016C15.1663 7.55316 15.1203 7.11683 15.0367 6.6945Z"
      fill="#1565C0"
    />
  </svg>
);
